<template>
  <div class="service" v-if="joinType == 3">
    <div class="first">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">服务商招商说明</div>
      </div>
      <div class="topTip">
        修正健康旨在寻找优质的服务商，共同为客户提供专业、高效、全面的服务。我们欢迎各类服务商加入我们的合作伙伴体系，共同打造一个互利
      </div>
      <div style="margin-top: 0.3rem">
        <div class="topTip">成为我们的经销商，您将享受到以下优势</div>
        <div class="list">
          <div class="item_advant" v-for="(item, index) in list" :key="index">
            <div style="display: flex; align-items: center">
              <img
                style="width: 0.49rem; height: 0.3rem"
                :src="item.image"
                alt=""
              />
              <div class="name_advant">{{ item.title }}</div>
            </div>
            <div class="con_advant">{{ item.content }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">服务商类型</div>
      </div>
      <div class="topTip">我们诚邀以下类型的服务商加入</div>
      <div class="ecology">
        <div class="ecology_all">
          <img
            class="ecology_img"
            src="../../../assets/images/serviceEcology.png"
            alt=""
          />
          <div class="ecology_bottom">
            <div class="ecology_word">服务生态</div>
            <div class="ecology_content">
              私域、全域等代运营类服务，店铺托管，客户服务系统、讲师培训、物流支持等。
            </div>
          </div>
        </div>
        <div class="ecology_all">
          <img
            class="ecology_img"
            src="../../../assets/images/flowEcology.png"
            alt=""
          />
          <div class="ecology_bottom">
            <div class="ecology_word">流量生态</div>
            <div class="ecology_content">
              主流平台达人/直播带货、特色渠道分销等。
            </div>
          </div>
        </div>
        <div class="ecology_all">
          <img
            class="ecology_img"
            src="../../../assets/images/contentEcology.png"
            alt=""
          />
          <div class="ecology_bottom">
            <div class="ecology_word">内容生态</div>
            <div class="ecology_content">
              新媒体图文内容创作、主流平台内容运营等。
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="third">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">合作优势</div>
      </div>
      <div class="cooperation">
        <div
          class="advantage"
          v-for="(item, index) in advantageList"
          :key="index"
        >
          <div class="advantage_title">
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin: 0.03rem 0;
              "
            >
              <div class="advantage_word">{{ item.name }}</div>
              <div class="line"></div>
            </div>
            <img
              style="width: 0.5rem; height: 0.5rem"
              :src="item.image"
              alt=""
            />
          </div>
          <div class="advantage_content">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <div class="fourth">
      <div class="bigTitle">
        <div class="line"></div>
        <div class="topic">商家入驻流程</div>
      </div>
      <div class="flowImg">
        <div>
          <img class="step" src="../../../assets/images/apply.png" alt="" />
          <div class="stepWord">01 提交申请</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img class="step" src="../../../assets/images/audit.png" alt="" />
          <div class="stepWord">02 资质审核</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img class="step" src="../../../assets/images/sign1.png" alt="" />
          <div class="stepWord">03 签约合作</div>
        </div>
        <img class="point" src="../../../assets/images/right.png" alt="" />
        <div>
          <img class="step" src="../../../assets/images/conduct.png" alt="" />
          <div class="stepWord">04 开展业务</div>
        </div>
      </div>
      <div class="connection">
        <div>
          <div class="con_cont">
            如果你对我们的服务商招商项目感兴趣，请随时联系我们。我们期待与你建立长期、稳定的合作关系，共同开创美好的未来！
          </div>
          <div class="con_person">联系方式：王经理</div>
        </div>
        <div style="text-align: center">
          <div class="qrcode">
            <img
              style="width: 1.71rem; height: 1.77rem"
              src="../../../assets/images/wxCode.png"
              alt=""
            />
          </div>
          <div class="addWx">（扫码加微信）</div>
        </div>
      </div>
    </div>
    <div class="five">
      <div class="apply">
        <div class="namePhone">
          <div>
            <div class="word">您的姓名：</div>
            <input class="input" v-model.trim="form.name" type="text" />
          </div>
          <div style="margin-left: 0.65rem">
            <div class="word">联系电话：</div>
            <input
              class="input"
              v-model.trim="form.mobile"
              maxlength="11"
              type="text"
            />
          </div>
        </div>
        <div class="namePhone">
          <div>
            <div class="word1">公司名称：</div>
            <input class="input" v-model.trim="form.company_name" type="text" />
          </div>
          <div style="margin-left: 0.65rem">
            <div class="word1">提供服务：</div>
            <input
              class="input"
              v-model.trim="form.services"
              maxlength="11"
              type="text"
            />
          </div>
        </div>
        <div class="detail">
          <div class="word">详细信息：</div>
          <textarea
            class="textArea"
            v-model.trim="form.contentText"
            placeholder="请输入您的详细信息，我们会尽快联系您（300字以内）"
          ></textarea>
        </div>
      </div>
      <div class="submit">
        <div class="button" @click="submitform">提交申请</div>
        <div class="tip">收到信息我们会第一时间与您联系！</div>
      </div>
    </div>
  </div>
</template>

<script>
import one from "../../../assets/images/01.png";
import two from "../../../assets/images/02.png";
import three from "../../../assets/images/03.png";
import four from "../../../assets/images/04.png";
import five from "../../../assets/images/05.png";
import six from "../../../assets/images/06.png";
import seven from "../../../assets/images/07.png";
import eight from "../../../assets/images/08.png";
import nine from "../../../assets/images/09.png";
import ten from "../../../assets/images/10.png";
import prospects from "../../../assets/images/prospects.png";
import resource from "../../../assets/images/resource.png";
import team from "../../../assets/images/team.png";
import mode from "../../../assets/images/mode.png";
export default {
  name: "",
  props: {
    joinType: {
      type: Number,
    },
  },
  data() {
    return {
      form: {
        contentText: "",
        mobile: "",
        name: "",
        services: "",
        company_name: "",
      },
      list: [
        {
          image: one,
          title: "优质产品",
          content:
            "30+合作工厂，自研自产品种，修正品牌背书，高品质产品和良好的市场竞争力。",
        },
        {
          image: two,
          title: "多元合作方式",
          content:
            "30+支持1件代发，零库存不压货，减少资金风险，批采&合作开品。",
        },
        {
          image: three,
          title: "丰厚利润",
          content: "30+提供具有竞争力的采购价格，获取更高的利润空间。",
        },
        {
          image: four,
          title: "多元盈利模式",
          content: "产品销售返利，激励政策返佣。",
        },
        {
          image: five,
          title: "稳定供应",
          content: "拥有强大的供应链体系，确保产品的稳定供应，让您无后顾之忧。",
        },
        {
          image: six,
          title: "完善合作模式",
          content: "产品区域保护，签约核心区域经营权限，利润最大化。",
        },
        {
          image: seven,
          title: "价格管控",
          content: "产品统一零售价控价，维护市场稳定。",
        },
        {
          image: eight,
          title: "市场支持",
          content: "总部品牌声势打造，市场物料支持。",
        },
        {
          image: nine,
          title: "培训赋能",
          content: "全面的营销培训和支持，帮助提升销售技巧和市场推广能力。",
        },
        {
          image: ten,
          title: "售后服务",
          content:
            "提供专属客服，售后全程保驾护航，帮助解决产品、销售、技术等市场运营问题。",
        },
      ],
      advantageList: [
        {
          name: "广阔的市场前景",
          image: prospects,
          content:
            "我们的平台拥有庞大的客户群体，为服务商提供广阔的业务发展空间。",
        },
        {
          name: "优质的客户资源",
          image: resource,
          content: "我们将为服务商提供优质的客户资源，帮助服务商拓展业务。",
        },
        {
          name: "专业的支持团队",
          image: team,
          content:
            "我们拥有一支专业的支持团队，为服务商提供全方位的支持和服务。",
        },
        {
          name: "合理的分成机制",
          image: mode,
          content: "我们将与服务商建立合理的分成机制，确保双方互利共赢。",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    submitform() {
      this.$emit("submitApply", {
        name: this.form.name,
        mobile: this.form.mobile,
        contentText: this.form.contentText,
        company_name: this.form.company_name,
        services: this.form.services,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.service {
  padding: 0.81rem 3.6rem 0;
  .first {
    .topTip {
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.26rem;
      color: #232323;
      margin-bottom: 0.14rem;
    }
    .list {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      .item_advant {
        width: 2.86rem;
        height: 1.68rem;
        background: #f4f7ff;
        border-radius: 0.04rem;
        margin-top: 0.18rem;
        padding: 0.17rem 0.14rem 0 0.14rem;
        box-sizing: border-box;
        &:not(:nth-of-type(4n)) {
          margin-right: 0.15rem;
        }
        .name_advant {
          font-family: OPPOSans, OPPOSans;
          font-weight: 700;
          font-size: 0.24rem;
          color: #4089fe;
          margin-left: 0.1rem;
        }
        .con_advant {
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 0.18rem;
          color: #999cb0;
          margin-top: 0.17rem;
        }
      }
    }
  }
  .second {
    margin-top: 0.43rem;
    .topTip {
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.26rem;
      color: #232323;
      margin-bottom: 0.14rem;
    }
    .ecology {
      height: 5.4rem;
      background: #f5f3fc;
      padding: 0.45rem 0.7rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      .ecology_all {
        width: 3rem;
        height: 4.5rem;
        border-radius: 0.1rem;
        overflow: hidden;
        .ecology_img {
          width: 3rem;
          height: 2.7rem;
        }
        .ecology_bottom {
          background: #fff;
          height: 1.8rem;
          box-sizing: border-box;
          padding: 0.2rem 0.28rem 0 0.28rem;
          .ecology_word {
            font-family: OPPOSans, OPPOSans;
            font-weight: normal;
            font-size: 0.26rem;
            color: #232323;
          }
          .ecology_content {
            margin-top: 0.05rem;
            font-family: OPPOSans, OPPOSans;
            font-weight: normal;
            font-size: 0.2rem;
            color: #666666;
          }
        }
      }
    }
  }
  .third {
    margin-top: 0.43rem;
    .cooperation {
      display: flex;
      justify-content: space-between;
      .advantage {
        padding: 0.16rem 0.23rem 0 0.23rem;
        width: 2.86rem;
        height: 1.68rem;
        box-sizing: border-box;
        border-radius: 0.04rem;
        border: 0.01rem solid #4089fe;
        .advantage_title {
          display: flex;
          justify-content: space-between;
          .advantage_word {
            font-family: OPPOSans, OPPOSans;
            font-weight: normal;
            font-size: 0.22rem;
            color: #232323;
          }
          .line {
            width: 0.54rem;
            height: 0.02rem;
            background: #4089fe;
          }
        }
        .advantage_content {
          margin-top: 0.12rem;
          font-family: OPPOSans, OPPOSans;
          font-weight: normal;
          font-size: 0.18rem;
          color: #7f8493;
        }
      }
    }
  }
  .fourth {
    margin-top: 0.43rem;
    .flowImg {
      display: flex;
      align-items: center;
      .step {
        width: 2.28rem;
        height: 1.62rem;
      }
      .stepWord {
        margin-top: 0.1rem;
        margin-left: 0.5rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.24rem;
        color: #232323;
      }
      .point {
        margin: 0 0.43rem;
        margin-top: -0.4rem;
      }
    }
    .connection {
      margin-top: 0.72rem;
      display: flex;
      justify-content: space-between;
      width: 12rem;
      height: 3.2rem;
      padding: 0.74rem 1.02rem 0 0.7rem;
      box-sizing: border-box;
      background: #fcfbff;
      .con_cont {
        width: 6.71rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.26rem;
        color: #232323;
      }
      .con_person {
        margin-top: 0.25rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.24rem;
        color: #232323;
      }
      .qrcode {
        width: 1.83rem;
        height: 1.83rem;
        line-height: 1.83rem;
        background: #ffffff;
        border-radius: 0.12rem;
        border: 0.03rem solid #4089fe;
        text-align: center;
      }
      .addWx {
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #495a7b;
        margin-top: 0.1rem;
      }
    }
  }
  .five {
    margin-top: 0.43rem;
    .apply {
      padding: 0 0.86rem;
      .word {
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.2rem;
        color: #232323;
        margin-bottom: 0.15rem;
        &::before {
          content: "*";
          color: red;
        }
      }
      .word1 {
        font-family: OPPOSans, OPPOSans;
        font-weight: 600;
        font-size: 0.2rem;
        color: #232323;
        margin-bottom: 0.15rem;
      }
      .namePhone {
        display: flex;
        margin-top: 0.25rem;
        .input {
          width: 4.8rem;
          height: 0.5rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
        }
      }
      .detail {
        margin: 0.31rem 0 0.1rem;
        .input {
          width: 10.29rem;
          height: 0.5rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
        }
        .textArea {
          width: 10.3rem;
          height: 2.16rem;
          box-sizing: border-box;
          padding: 0.19rem 0 0 0.23rem;
          border-radius: 0.06rem;
          border: 0.02rem solid #cdcdcd;
          outline: none;
        }
      }
    }
    .submit {
      text-align: center;
      margin-top: 0.62rem;
      .button {
        margin: 0 auto;
        width: 2.4rem;
        height: 0.5rem;
        line-height: 0.5rem;
        background: #4089fe;
        border-radius: 0.25rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.28rem;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
      .tip {
        margin-top: 0.18rem;
        font-family: OPPOSans, OPPOSans;
        font-weight: normal;
        font-size: 0.18rem;
        color: #232323;
      }
    }
  }
  .bigTitle {
    display: flex;
    align-items: center;
    margin-bottom: 0.36rem;
    .line {
      width: 0.08rem;
      height: 0.42rem;
      background: #4089fe;
      border-radius: 0.04px;
    }
    .topic {
      margin-left: 0.22rem;
      font-family: OPPOSans, OPPOSans;
      font-weight: normal;
      font-size: 0.4rem;
      color: #232323;
    }
  }
}
</style>
